import './Footer.scss';
import DisclaimerComponent from '@zappy-ride/disclaimer-footer-component';

const Footer = () => {
  return (
    <div className="Footer">
      <div className="container">
        <div>
          <span className="disclaimer_container">
            <DisclaimerComponent
              clientName="PSEG"
              textStyle={{
                fontFamily: 'BentonSans',
                fontSize: '10px',
              }}
              imageStyle={{
                marginTop: '30px',
                maxWidth: '100%',
                marginBottom: '30px',
              }}
              wrapperStyle={{
                padding: '0px',
              }}
            />
          </span>
        </div>
      </div>
    </div>
  );
};

export default Footer;
